import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";


const Logo = styled.img`
  width: 150pt;
  @media (max-width: 899px) {
    width: 120pt;
  }
`

const ErrorFallback: React.FC = () => {
  return (
    <header>
      <Grid container direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Grid item xs={12} textAlign={"center"} style={{ margin: 100 }}>
          <Link to={"/"}>
          <Logo
              src={"/logo.png"}
              alt={"Bhagya Perera Art"}
            />
          </Link>
        </Grid>
        <Grid item xs={12} textAlign={"center"}>
          <h3>Well, this is embarrassing. Something's not right!</h3>
          <p style={{ textAlign: 'center' }}>Please <Link style={{ color: '#000' }} to={"/"}>click here</Link> to go to the home page.</p>
        </Grid>
      </Grid>
    </header>
  );
};

export default ErrorFallback;
